// extracted by mini-css-extract-plugin
module.exports = {"container":"MapSection_container__vOsqA","activeArena":"MapSection_activeArena__3j9se","mapContainer":"MapSection_mapContainer__19Y3s","spinner":"MapSection_spinner__aY-qn"};